import React, { Component } from 'react';
import Loader from '../Loader/Loader';
import SaveCardForm from './SaveCardForm';
import './SaveThdCreditCard.css';
import * as utils from './Utils';
import thdcustomer from '@thd-olt-global/thd-customer';
import { logEvents } from './Logger.service';

export default class SaveThdCardWrapper extends Component {
    constructor (props) {
        super(props);
        this.state = {
            renderFormParameters: false
        }
    }
    componentDidMount () {
        if (this.isSaveCardToProfileEnabled()) {
            this.initSaveCardToProfile();
            return;
        } else {
            this.redirectToDefaultApplynow();
        }
    }
    isSaveCardToProfileEnabled = () => {
        let isSaveCardToProfileEnabled = false;
        if (!thdcustomer.isB2BCustomer && !thdcustomer.isB2XCustomer && window.THD_ACCOUNT_GLOBAL && window.THD_ACCOUNT_GLOBAL.featureSwitches) {
            isSaveCardToProfileEnabled = (window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_SAVE_CARD_TO_PROFILE_ENABLED === 1 || utils.readCookie('HD_SCTP'));
            if (isSaveCardToProfileEnabled && window.THD_ACCOUNT_GLOBAL.isNativeApp === 'true' && utils.isNewerConsumerAppVersion(utils.baseConsumerAppVersion)) {
              isSaveCardToProfileEnabled = (window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_SAVE_CARD_TO_PROFILE_NATIVEAPP === 1 || utils.readCookie('SCTP_APP'));
              if (isSaveCardToProfileEnabled && window.THD_ACCOUNT_GLOBAL.featureSwitches.CITI_SCTP_APP_GUESTUSER_ENABLED === 0 && !thdcustomer.isLoggedIn) {
                isSaveCardToProfileEnabled = false;
              }
            }
        }
        return isSaveCardToProfileEnabled;
    };
    redirectToDefaultApplynow = () => {
       window.location.href = utils.getCitiApplynowUrl();
    };
    initSaveCardToProfile = () => {
        if (utils.getURLParameters().cmp || utils.getURLParameters().step) {
            this.renderFormParams();
            return true;
        } else if (utils.readThdSctpCookie().ci && utils.readThdSctpCookie().ct ) {
            this.invokeSaveCardAfterApply();
            return true;
        } else {
            //this.redirectToDefaultApplynow();
            let logObj = {
                message: 'error reading params cmp, step, ci, ct',
                urlParam: window.location.search,
                description: ''
            };
            if (!utils.readThdSctpCookie().d || (document.referrer && document.referrer.indexOf('/account/view/paymentcards') != -1)) {
                logObj.description = 'deviceId not available in cookie, referrer is paymentCards page';
                logEvents(logObj);
                this.redirectToOriginPage();
            } else {
                logEvents(logObj);
                this.redirectToPaymentCardsPage(false);
            }
            return true;
        }
    }
    renderFormParams = async () => {
        let data = await utils.callRenderFormParamsApi();
        if (data.customerId) {
            const formDataObject = { ...data };
            formDataObject.returnPage = this.getReturnPage();
            this.setState({
                renderFormParameters: true,
                saveCardFormParams: formDataObject
            });
        } else {
            logEvents('redirecting to default applynow due to renderForm api error');
            this.redirectToDefaultApplynow();
        }
    };
    invokeSaveCardAfterApply = () => {
        const sctpCookie = utils.readThdSctpCookie();
        const logObj = {
            applicationStatus: sctpCookie.s ? sctpCookie.s : 'status not available',
            isReferenceIdAvailable: sctpCookie.r ? 'true' : 'false',
            isSignedinUser: thdcustomer.isLoggedIn ? 'true' : 'false',
            isPostSignin: utils.getURLParameters().savecardtoprofileflow ? 'true' : 'false'
        };
        logEvents(logObj);
        if (sctpCookie.r
            && sctpCookie.s === 'A'
            && sctpCookie.d) {
              if (thdcustomer.isLoggedIn) {
                this.invokeSaveCardApi(sctpCookie.ic);
              } else {
                //logEvents('got the referenceId and redirecting guest user to login page')
                utils.redirectToLogin();
              }
        } else {
            utils.deleteBrowserCookie('THD_SCTP', utils.getDomain());
            this.redirectToOriginPage();
        }
    };
    invokeSaveCardApi = async (insideCheckout) => {
        if (thdcustomer.isB2BCustomer) {
            logEvents('redirecting b2b user to payment cards page with error message');
            this.redirectToPaymentCardsPage(false, insideCheckout);
        } else {
            const data = await utils.callSaveCardEndpoint();
            const isSaveCardSuccess = data && data.saveCard;
            this.redirectToPaymentCardsPage(isSaveCardSuccess, insideCheckout);
        }
    }

    redirectToPaymentCardsPage = (success, insideCheckout) => {
        if (window.localStorage) {
          window.localStorage.removeItem('sctp_w');
        }
        utils.deleteBrowserCookie('THD_SCTP', utils.getDomain());
        const saveCardParam = (success === true) ? '?saveCard=success' : '?saveCard=fail'
        const b2bPath = thdcustomer.isB2BCustomer ? '/b2b' : '';
        const originUrlParam = utils.getOriginPageUrl() ? '&originUrl=' + encodeURIComponent(utils.getOriginPageUrl()): '';
        if (insideCheckout) {
            const saveCardStatus = success ? 'success' : 'fail';
            window.sessionStorage && sessionStorage.setItem('isSctp', saveCardStatus);
            logEvents('redirecting to checkout page with saveCardStatus '+saveCardStatus);
            window.location.href = '/mycheckout/checkout';
        } else {
            window.location.href = b2bPath + '/account/view/paymentcards' + saveCardParam + originUrlParam;
        }
    }

    getReturnPage = () => {
        const originUrlParam = utils.getOriginPageUrl() ? '?originUrl=' + encodeURIComponent(utils.getOriginPageUrl()): '';
        return '/account/view/savecardtoprofile' + originUrlParam;
    }
    redirectToOriginPage = () => {
        const originPage = utils.getOriginPageUrl();
        window.location.href = originPage ? originPage : 'https://www.homedepot.com';
    }
    getLoaderMessage = () => {
        let loaderMessage = '';
        if (utils.getURLParameters().step) {
            loaderMessage = 'Redirecting To Citibank';
        } else if (utils.readThdSctpCookie().r) {
            loaderMessage = 'Saving Your Card';
        }
        return loaderMessage;
    }
    render () {
        return (
            <div className = "saveThdCard">
                <Loader message = {this.getLoaderMessage()}></Loader>
                { this.state.renderFormParameters &&
                <SaveCardForm formData = {this.state.saveCardFormParams} >
                </SaveCardForm> }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/SaveThdCreditCard/SaveThdCreditCard.js